type FormatToCurrencyProps = {
  value: number | string;
  locale?: string;
  currency?: Intl.NumberFormatOptions['currency'];
};

export class MathManager {
  static formatCurrency({
    value,
    locale = 'pt-BR',
    currency = 'BRL',
  }: FormatToCurrencyProps) {
    const parseNumber = Number(value);

    if (Number.isNaN(parseNumber)) throw new Error ('Argument value doesnt Number type')

      return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
    })
      .format(parseNumber)
      .replace(/\s+/g, '');
  }
  static percentageToValue(percentage: number, value: number) {
    return (percentage / 100) * value;
  }
}
